import React, { useEffect } from 'react';
import { TopBar } from '../components/landing/TopBar';
import { Hero } from '../components/landing/Hero';
import { PainPoints } from '../components/landing/PainPoints';
import { Mechanism } from '../components/landing/Mechanism';
import { AuthorStory } from '../components/landing/AuthorStory';
import { ContentMap } from '../components/landing/ContentMap';
import { Bonuses } from '../components/landing/Bonuses';
import { Testimonials } from '../components/landing/Testimonials';
import { CostPerspective } from '../components/landing/CostPerspective';
import { WhoIsFor } from '../components/landing/WhoIsFor';
import { ValueStack } from '../components/landing/ValueStack';
import { Guarantee } from '../components/landing/Guarantee';
import { Urgency } from '../components/landing/Urgency';
import { FAQ } from '../components/landing/FAQ';
import { EmotionalClose } from '../components/landing/EmotionalClose';
import { FinalCTA } from '../components/landing/FinalCTA';
import { Footer } from '../components/landing/Footer';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function LandingPage() {
  const {
    trackEvent
  } = useMetaPixel();
  useEffect(() => {
    document.documentElement.lang = 'es';
  }, []);
  const handleAddToCart = () => {
    trackEvent('AddToCart');
  };
  return <div className="min-h-screen bg-dark-primary text-cream font-sans selection:bg-gold/30 selection:text-cream" data-id="element-812">
      <TopBar onAddToCart={handleAddToCart} data-id="element-813" />

      <main className="pt-16 md:pt-20" data-id="element-814">
        <Hero onAddToCart={handleAddToCart} data-id="element-815" />
        <PainPoints data-id="element-816" />
        <Mechanism data-id="element-817" />
        <AuthorStory data-id="element-818" />
        <ContentMap data-id="element-819" />
        <Bonuses data-id="element-820" />
        <ValueStack onAddToCart={handleAddToCart} data-id="element-821" />
        <Testimonials data-id="element-822" />
        <CostPerspective data-id="element-823" />
        <WhoIsFor onAddToCart={handleAddToCart} data-id="element-824" />
        <FAQ data-id="element-825" />
        <EmotionalClose onAddToCart={handleAddToCart} data-id="element-826" />
      </main>

      <Footer data-id="element-827" />

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 right-0 bg-dark-primary border-t border-gold/20 p-4 md:hidden z-50 flex items-center justify-between" data-id="element-828">
        <div className="flex flex-col" data-id="element-829">
          <span className="font-serif text-sm text-cream" data-id="element-830">
            El Azúcar Silencioso
          </span>
          <span className="font-sans font-bold text-gold" data-id="element-831">$17.95</span>
        </div>
        <a href="https://www.godeskcore.com/cart/42794527916080:1" target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} className="bg-gold hover:bg-gold/90 text-dark-primary font-sans font-bold text-sm py-3 px-6 rounded transition-colors" data-id="element-832">
          Comprar + Descargar
        </a>
      </div>
    </div>;
}